export default "__VITE_ASSET__Dy0TXU47__"